import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  LiveScoreCash,
  LiveScoreCoef,
  LiveScoreColumnContainer,
  LiveScoreColumnHeader,
  LiveScoreEach,
  LiveScorePlayer,
} from "./liveScoresComponentsStyles/LiveScoresColumnStyles";
import { v4 as uuid } from "uuid";
import { AppContext } from "../../../../../context/createContext";
import {
  cashAmount,
  numberWithCommas,
} from "./liveScoresComponentHelpers/liveScoresHelper";
import floorFigure from "../../../../configs/floorFigure";
import { useTranslation } from "../../../../../locale/context";

const LiveScoresPrevColumn = () => {
  const {
    allPreviousRounds,
    stellarSocketMessages,
    auth: { player_id, player_name },
    config,
  } = useContext(AppContext);

  const { t } = useTranslation();
  const languagePack = useMemo(() => {
    return {
      user: t("common.liveBet.table.user"),
      bet: t("common.liveBet.table.bet"),
      mult: t("common.liveBet.table.mult"),
      win: t("common.liveBet.table.win"),
    };
  }, [t]);

  const allPreviousRoundsMessage = (message: any) =>
    message.getFullPreviousRounds();

  const [userRounds, setUserRounds] = useState<any[]>([]);
  const [othersRounds, setOthersRounds] = useState([]);

  useEffect(() => {
    const userRound = allPreviousRounds
      .filter((round: any) => round.id === player_id)
      .map((round: any) => {
        return { ...round, name: player_name };
      });
    const othersRound = allPreviousRounds.filter(
      (round: any) => round.id !== player_id
    );
    setUserRounds(userRound);
    setOthersRounds(othersRound);
  }, [allPreviousRounds]);

  useEffect(() => {
    allPreviousRoundsMessage(stellarSocketMessages);
  }, []);

  return (
    <LiveScoreColumnContainer>
      <LiveScoreColumnHeader>
        <h1>{languagePack.user}</h1>
        <h1>{languagePack.bet}</h1>
        <h1>{languagePack.mult}</h1>
        <h1>{languagePack.win}</h1>
      </LiveScoreColumnHeader>
      {userRounds.map(
        (eachUser: any) =>
          eachUser.bet !== 0 && (
            <LiveScoreEach winner={eachUser.win > 0} key={uuid()}>
              <LiveScorePlayer>{eachUser.name}</LiveScorePlayer>
              <LiveScoreCash>
                {eachUser.bet !== 0
                  ? cashAmount(eachUser.currency, eachUser.bet, config.prec)
                  : "----"}
              </LiveScoreCash>
              <div>
                <LiveScoreCoef number={eachUser.coeff}>
                  {eachUser.coeff > 0 ? eachUser.coeff + "x" : "----"}
                </LiveScoreCoef>
              </div>
              <LiveScoreCash>
                {eachUser.win !== 0
                  ? numberWithCommas(
                      eachUser.currency,
                      floorFigure(eachUser.win, config.prec),
                      config.prec
                    )
                  : "----"}
              </LiveScoreCash>
            </LiveScoreEach>
          )
      )}
      {othersRounds.map(
        (eachUser: any) =>
          eachUser.bet !== 0 && (
            <LiveScoreEach winner={eachUser.win > 0} key={uuid()}>
              <LiveScorePlayer>{eachUser.name}</LiveScorePlayer>
              <LiveScoreCash>
                {eachUser.bet !== 0
                  ? cashAmount(eachUser.currency, eachUser.bet, config.prec)
                  : "----"}
              </LiveScoreCash>
              <div>
                <LiveScoreCoef number={eachUser.coeff}>
                  {eachUser.coeff > 0 ? eachUser.coeff + "x" : "----"}
                </LiveScoreCoef>
              </div>
              <LiveScoreCash>
                {eachUser.win !== 0
                  ? numberWithCommas(
                      eachUser.currency,
                      floorFigure(eachUser.win, config.prec),
                      config.prec
                    )
                  : "----"}
              </LiveScoreCash>
            </LiveScoreEach>
          )
      )}
    </LiveScoreColumnContainer>
  );
};

export default LiveScoresPrevColumn;
